import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import HomeIcon from "@material-ui/icons/Home";
import "./SuccessPage.css";
import ConfigurationManager from "../../configuration/ConfigurationManager";
import { I18nContext } from "../../I18nProvider";

//let uri = ConfigurationManager.getProperty('WBCP_HOST')
export class SuccessPage extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this._handleHomeClick = this._handleHomeClick.bind(this);
    this._handleSubmissionClick = this._handleSubmissionClick.bind(this);
  }

  _handleHomeClick(event) {
    window.location.href = "/#!/home";
  }

  _handleSubmissionClick(event) {
    var actualSubmission = window.location.pathname.split("/")[2];
    window.location.href = `/submit/${actualSubmission}/`;
  }

  render() {
    const appText = this.context;

    let successUrl =
      ConfigurationManager.getProperty("WBCP_HOST") +
      "/submit/marketing/static/media/check.01084c13.svg";
    return (
      <div>
        <div className="submit-info">
          <img alt="success" src={successUrl} className="success-tick" />
          {/* <h4 className="sucess-text">Submission complete!</h4> */}
          <h4 className="sucess-text">{appText.T442}</h4>
          <h5 className="sucess-jobid">
            {appText.T738}: {this.props.jobId}
          </h5>
        </div>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            className="button"
            onClick={this._handleHomeClick}
          >
            {appText.T444}
            <HomeIcon className="home" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            className="button"
            onClick={this._handleSubmissionClick}
          >
            {appText.T445}
            <CloudUploadIcon className="submission" />
          </Button>
        </div>
      </div>
    );
  }
}

export default SuccessPage;
